export const LOGIN_EMAIL = '/member/login/email'
